<script>
    import Money from "./Money.svelte";
    import ShopifyImage from "./ShopifyImage.svelte";
    import CartSubscriptionUpsell from "./CartSubscriptionUpsell.svelte";

    import { isCartUpdating } from "../store/store";
  import { fade } from "svelte/transition"

    export let item;
    export let removeItem;
    export let updateItem;
    export let line;
    export let onConverted;

    $: options = item.selected_options || [];
    $: giftCardProperties = Object.entries(item.properties || {}).filter(
        ([key, value]) =>
            value &&
            !key.startsWith('__shopify') &&
            !['_rc_bundle', '_rc_bundle_parent', '_rc_bundle_variant'].includes(key),
    );

    /**
   * @type {string | number | NodeJS.Timeout | undefined}
   */
    let timmer;

    function quantityDec(item) {
        
            updateItem(item, item.quantity - 1);
        
    }
    function quantityInc(item) {

            updateItem(item, item.quantity + 1);
    }
</script>

{@debug item}
<li class="" transition:fade>
    <div class="grid grid-cols-[6rem,auto] w-full items-start space-x-4">
        <div
            class="row-span-2 flex-shrink-0 overflow-hidden rounded-md border bg-gray-50"
        >
            <ShopifyImage
                image={item.featured_image}
                classList="h-full w-full object-cover mix-blend-multiply object-center"
                sizes="(min-width: 100px) 100px"
                loading="lazy"
            />
        </div>

        <div class="flex justify-between">
            <a class="block leading-tight" href={`/products/${item.handle}`}>
                {@html item.title}

                {#if item.selling_plan_allocation?.selling_plan}
                <span class="flex gap-2 items-center mt-2 text-sm">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.3333 12.5831C12.7475 11.5527 13.6666 9.88367 13.6666 7.99998C13.6666 4.87037 11.1295 2.33332 7.99992 2.33332H7.66659M7.99992 13.6666C4.87031 13.6666 2.33325 11.1296 2.33325 7.99998C2.33325 6.11629 3.25236 4.44727 4.66659 3.41692M7.33325 14.9333L8.66659 13.6L7.33325 12.2666M8.66659 3.73332L7.33325 2.39998L8.66659 1.06665" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                        
                    {item.selling_plan_allocation.selling_plan.name}
                </span>
                {/if}
            </a>
            
            <button
                on:click={() => {
                    removeItem(item);
                }}
                type="button"
                title="Delete"
                class="-mt-3 p-3 flex-shrink-0 font-semibold dark:text-gray-50 text-gray-900 hover:text-gray-700 dark:hover:text-yellow-600"
                disabled={$isCartUpdating}>
                    <svg class="w-5 h-5  -mr-1" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.66667 3.99992V3.46659C9.66667 2.71985 9.66667 2.34648 9.52134 2.06126C9.39351 1.81038 9.18954 1.60641 8.93865 1.47858C8.65344 1.33325 8.28007 1.33325 7.53333 1.33325H6.46667C5.71993 1.33325 5.34656 1.33325 5.06135 1.47858C4.81046 1.60641 4.60649 1.81038 4.47866 2.06126C4.33333 2.34648 4.33333 2.71985 4.33333 3.46659V3.99992M1 3.99992H13M11.6667 3.99992V11.4666C11.6667 12.5867 11.6667 13.1467 11.4487 13.5746C11.2569 13.9509 10.951 14.2569 10.5746 14.4486C10.1468 14.6666 9.58677 14.6666 8.46667 14.6666H5.53333C4.41323 14.6666 3.85318 14.6666 3.42535 14.4486C3.04903 14.2569 2.74307 13.9509 2.55132 13.5746C2.33333 13.1467 2.33333 12.5867 2.33333 11.4666V3.99992" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
            </button>
        </div>

        <div class="flex justify-between items-center">
            <p class="text-gray-500 mt-3 flex">
                <button class="border border-r-0 py-2 px-3 border-gray-300" on:click={() => quantityDec(item)}>
                    -
                </button>
                <input type="text" min="1" max="100" on:change|preventDefault={(e) => updateItem(item, e.target.value)} value={item.quantity} class="w-16 py-2 border-x-0 border-y border-gray-300 text-center" />
                <button class="border border-l-0 py-2 px-3 border-gray-300" on:click={() => quantityInc(item)}>
                    +
                </button>
            </p>

            <div class="text-lg">
                {#if item.selling_plan_allocation}
                <span class="line-through text-sm">
                    <Money price={item.selling_plan_allocation.compare_at_price*item.quantity} />
                </span>
                {/if}
                <Money price={item.final_line_price} />
            </div>
        </div>
    </div>

    <div class="mt-4 space-y-1">
        {#each giftCardProperties as [key, value]}
            <div class="flex justify-between text-sm text-gray-600">
                <span class="font-medium">{key}:</span>
                <span>{value}</span>
            </div>
        {/each}

        {#each options as option}
            {#if option.name == 'RingSize'}
                {#each item.attributes || [] as attribute}
                <div class="flex justify-between">
                    <span class="font-medium">
                        {#if attribute.key == 'marime_dama'}
                            Marime Inel Femei:
                        {:else if attribute.key == 'marime_barbati'}
                            Marime Inel Barbati:
                        {:else if attribute.key == 'inscriptionare_font'}
                            Font Inscriptionare:
                        {:else if attribute.key == 'inscriptionare_mesaj'}
                            Text Inscriptionare:
                        {:else}
                            {attribute.key}:
                        {/if}
                    </span>
                    <span>
                        {attribute.value}
                    </span>
                </div>
                {/each}
            {:else if option.value !== 'Default Title'}
                <div class="flex justify-between">
                    <span class="font-medium">
                        {option.name}:
                    </span>
                    <span>
                        {option.value}
                    </span>
                </div>
            {/if}
        {/each}

        {#if item.line_price !== item.final_line_price}
            <div class="text-gray-600 border-t dark:border-gray-600 border-gray-200 py-2">
                {#if item.discounts}
                    {#each item.discounts as discount}
                        <div class="flex justify-between mt-1">
                            {#if discount.title}
                                <span class="font-medium">Discount ({discount.title}):</span>
                            {:else}
                                <span class="font-medium">Discount:</span>
                            {/if}
                            
                            <Money isNegative={true} price={discount.amount} />
                        </div>
                    {/each}
                {/if}
                <div class="flex justify-between">
                    <span class="font-medium">Price:</span>
                    <Money price={item.line_price} />
                </div>
            </div>
        {/if}
    </div>

    <CartSubscriptionUpsell {item} {line} {onConverted} />
</li>